import l from './empty-layout.vue';

export default l;
